export enum Profile {
    BACK_OFFICE_LOGIN_EVENT = 'BACK_OFFICE_LOGIN_EVENT'
}